module.exports = "@media (max-width: 767px) {\r\n  /* On small screens, the nav menu spans the full width of the screen. Leave a space for it. */\r\n  .body-content {\r\n    padding-top: 50px;\r\n  }\r\n}\r\n.book-appointment-h1 h1 {\r\n\tfont-family: inherit;\r\n    font-size: 22px;\r\n    color: #453e79;\r\n    text-transform: uppercase;\r\n    letter-spacing: 7px;\r\n    padding: 5px 15px;\r\n    display: inline-block;\r\n    border: 1px solid #dad8e4;\r\n    margin-top: 35px;\r\n    margin-bottom: 25px;\r\n    text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main